export const environment = {
  production: false,
  newPortalUrl:
    'https://platform-dev-qtuqwab95uv7a6cvukcqpdr8e3tckh4s.inpress.be/client-corner-2/',
  disableConnectivityChecks: true,
  shouldAuthenticateWithVE: true,
  veClientId: 'be.inpress.platform-dev-qtuqwab95uv7a6cvukcqpdr8e3tckh4s',
  veDashboardUrl: 'https://erpve.be/klantenportaal/index.php',
};
